import { Paper, Stack, Text } from "@mantine/core";
import { IconLock } from "@tabler/icons-react";
import { CORE_RULES } from "@/config/assistant-core-rules";
import type { AssistantStyleText } from "@/locales/assistant-style";

interface Props {
	t: AssistantStyleText;
	lang: "id" | "en";
}

/** Blok hanya-baca larangan inti — sumbernya `CORE_RULES`, sama dengan prompt sistem. */
export function StyleCoreRules({ t, lang }: Props) {
	return (
		<Paper
			withBorder
			radius="md"
			p="md"
			bg="var(--mantine-color-default-hover)"
		>
			<Stack gap={6} data-style-core-rules>
				<Text fw={600} size="sm">
					<IconLock
						size={14}
						style={{ verticalAlign: "-2px", marginRight: 6 }}
					/>
					{t.core.title}
				</Text>
				<Text size="xs" c="dimmed">
					{t.core.description}
				</Text>
				{CORE_RULES.map((rule) => (
					<Text key={rule.key} size="sm" data-core-rule={rule.key}>
						<Text span fw={600}>
							{t.core.larangan}:
						</Text>{" "}
						{rule.text[lang].larangan}.{" "}
						<Text span fw={600}>
							{t.core.pengganti}:
						</Text>{" "}
						{rule.text[lang].pengganti}.
					</Text>
				))}
			</Stack>
		</Paper>
	);
}
